import React, { PropsWithChildren, ReactElement } from 'react';
import { Box, Divider, Typography } from '@mui/material';

export function PropertiesPanelSubtitle(props: PropsWithChildren<{ endButton?: ReactElement | null }>) {
  return (
    <Box sx={{ marginBottom: 1 }}>
      <Box sx={{ display: 'flex' }}>
        <Typography variant="subtitle1" sx={{ alignSelf: 'center', marginTop: 2, marginRight: 'auto' }}>
          {props.children}
        </Typography>

        {props.endButton}
      </Box>

      <Divider />
    </Box>
  );
}
